import { render, staticRenderFns } from "./formPenilaian.vue?vue&type=template&id=742bc089&"
import script from "./formPenilaian.vue?vue&type=script&lang=js&"
export * from "./formPenilaian.vue?vue&type=script&lang=js&"
import style0 from "./formPenilaian.vue?vue&type=style&index=0&id=742bc089&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports